import { useAppSelector } from 'hooks/hooks'
import { useCurrentCountry } from 'hooks/miscHooks'
import ReportExportButton from './common/ReportExportButton'
import ReportPageTemplate from './common/ReportPageTemplate'
import FingerprintSignupReportFilter from './FingerprintSignupReportFilter'
import FingerprintSignupReportList from './FingerprintSignupReportList'

const FingerprintSignupReportPage = () => {
    const country = useCurrentCountry()
    const { filters, summary } = useAppSelector((state) => state.fingerprintSignupReport)

    return (
        <ReportPageTemplate
            title="Fingerprint sign-up report"
            description="Passive Fingerprint.com visitor IDs captured at provider sign-up (MVP). Identification only runs after marketing consent, so these numbers cover part of the funnel rather than all of it. Coverage is a lower bound: it divides by every provider created in the period, including ones added by Office or by imports that never saw a sign-up page, so the real consent rate is higher than shown. Use filters to narrow by date; country follows the Office country switch."
            exportButton={
                <ReportExportButton
                    exportEndpoint="office/fingerprint-signup-report/export"
                    filters={filters}
                    country={country}
                />
            }
            filterComponent={
                <>
                    {summary !== null && (
                        <div className="mb-4 flex flex-wrap gap-6 text-md text-grey-800">
                            <span>
                                <strong>Total events:</strong> {summary.total_events}
                            </span>
                            <span>
                                <strong>Distinct visitors:</strong> {summary.distinct_visitors}
                            </span>
                            <span>
                                <strong>Visitors with multiple sign-ups:</strong>{' '}
                                {summary.visitors_with_multiple_signups}
                            </span>
                            <span title="Lower bound: the denominator counts every provider created in the period, including Office and imported ones that never saw a sign-up page.">
                                <strong>Coverage (min):</strong> {summary.coverage_rate}% (
                                {summary.total_events} of {summary.signups_in_period} providers
                                created)
                            </span>
                        </div>
                    )}
                    <FingerprintSignupReportFilter />
                </>
            }
            listComponent={<FingerprintSignupReportList />}
        />
    )
}

export default FingerprintSignupReportPage
